<ng-form
  [formGroup]="coveredHopperForm"
  *ngIf="hopperCartOptions"
  id="ng-form_2e36e473"
>
  <div class="options-card" id="div_options-card_a66e4a99">
    <div class="options-card-header" id="div_options-card-header_9f12bb77">
      LINING
    </div>

    <div class="options-card-body" id="div_options-card-body_51f02a7d">
      <div
        class="options-card-subheader body-item"
        id="div_options-card-subheader_1978d70f"
      >
        What are your lining requirements?
      </div>

      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_ac8fb485"
      >
        <p-checkbox
          class="checkbox-option"
          *ngFor="
            let option of hopperCartOptions['lining-requirements'];
            let first = first
          "
          [class.first]="first"
          [value]="option"
          [formControl]="
            $any(coveredHopperForm.controls['lining-requirements'])
          "
          [inputId]="option.id"
          name="lining-requirements"
          [label]="option.name"
          id="p-checkbox_checkbox-option_0d3ae073"
        ></p-checkbox>
      </div>
    </div>
  </div>

  <div class="options-card" id="div_options-card_a2e6d1a4">
    <div class="options-card-header" id="div_options-card-header_569031bd">
      VIBRATOR BRACKETS
    </div>

    <div class="options-card-body" id="div_options-card-body_a89904dd">
      <div
        class="options-card-subheader body-item"
        id="div_options-card-subheader_ccfb6a29"
      >
        Do you need vibrator brackets?
      </div>

      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_bccc6e8b"
      >
        <p-radioButton
          *ngFor="
            let vb of hopperCartOptions['vibrator-brackets'];
            let first = first
          "
          class="checkbox-option"
          [class.first]="first"
          formControlName="vibrator-brackets"
          name="vibrator-brackets"
          [label]="vb.name"
          value="vb"
          [value]="vb"
          id="p-radioButton_checkbox-option_d688dd9f"
        ></p-radioButton>
      </div>
    </div>
  </div>

  <input
    formControlName="selected"
    type="hidden"
    [value]="true"
    id="input_1acb4f45"
  />
</ng-form>

<p-progressSpinner
  fxLayout="column"
  fxFlexAlign="center center"
  *ngIf="!hopperCartOptions"
  id="p-progressSpinner_0c503069"
></p-progressSpinner>

<div class="button-container" id="div_button-container_525d13d3">
  <button
    icon="pi pi-arrow-left"
    (click)="back()"
    class="back-button"
    pButton=""
    label="Previous"
    id="button_back-button_17806e2d"
  ></button>

  <button
    class="quiz-button"
    styleClass="p-button-next"
    [disabled]="!coveredHopperForm.valid"
    (click)="next()"
    icon="pi pi-arrow-right"
    pButton=""
    label="Next"
    id="button_quiz-button_b8a30e64"
  ></button>
</div>
